module.exports = __webpack_public_path__ + "components/tooltips/static/chill-95f247bf35710d6e2f783abe48592ac1.jpg";